"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Pagination = require("@material-ui/lab/Pagination");
var _mdiMaterialUi = require("mdi-material-ui");
var _Pagination2 = _interopRequireDefault(require("./Pagination.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Pagination = function Pagination(_ref) {
  var numPages = _ref.numPages,
    pageNumber = _ref.pageNumber,
    _ref$defaultPage = _ref.defaultPage,
    defaultPage = _ref$defaultPage === void 0 ? 1 : _ref$defaultPage,
    _ref$boundaryCount = _ref.boundaryCount,
    boundaryCount = _ref$boundaryCount === void 0 ? 5 : _ref$boundaryCount,
    _ref$siblingCount = _ref.siblingCount,
    siblingCount = _ref$siblingCount === void 0 ? 0 : _ref$siblingCount,
    _ref$showPageNumbers = _ref.showPageNumbers,
    showPageNumbers = _ref$showPageNumbers === void 0 ? true : _ref$showPageNumbers,
    _ref$hidePrevButton = _ref.hidePrevButton,
    hidePrevButton = _ref$hidePrevButton === void 0 ? false : _ref$hidePrevButton,
    _ref$hideNextButton = _ref.hideNextButton,
    hideNextButton = _ref$hideNextButton === void 0 ? false : _ref$hideNextButton,
    onChangePage = _ref.onChangePage;
  var classes = (0, _Pagination2.default)();
  var _usePagination = (0, _Pagination.usePagination)({
      page: pageNumber,
      showFirstButton: false,
      showLastButton: false,
      hidePrevButton: hidePrevButton,
      hideNextButton: hideNextButton,
      count: numPages,
      defaultPage: defaultPage,
      boundaryCount: boundaryCount,
      siblingCount: siblingCount,
      onChange: onChangePage
    }),
    items = _usePagination.items;
  return /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: classes.ul
  }, items.map(function (_ref2) {
    var _classnames;
    var page = _ref2.page,
      type = _ref2.type,
      selected = _ref2.selected,
      onClick = _ref2.onClick,
      disabled = _ref2.disabled;
    var children = null;
    var cssButton = (0, _classnames2.default)(classes.button, (_classnames = {}, _defineProperty(_classnames, classes.buttonSelected, selected), _defineProperty(_classnames, classes.disabledButton, disabled), _classnames));
    if (!showPageNumbers && (type === 'start-ellipsis' || type === 'end-ellipsis' || type === 'page')) {
      return null;
    }
    if (type === 'start-ellipsis' || type === 'end-ellipsis') {
      children = '…';
    } else if (type === 'page') {
      children = /*#__PURE__*/_react.default.createElement("button", {
        className: cssButton,
        type: "button",
        onClick: onClick,
        disabled: disabled
      }, page);
    } else {
      children = /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: cssButton,
        onClick: onClick,
        disabled: disabled
      }, type === 'previous' && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.ChevronLeft, null), type === 'next' && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.ChevronRight, null));
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "".concat(type, "-").concat(page)
    }, children);
  })));
};
var _default = Pagination;
exports.default = _default;